<script setup>
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableRowRounded from "@/components/global-themed/table/TableRowRounded.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {formatDate} from "@/composables/useDates";
import {useEmailLogs} from "@/composables/email-logs/useEmailLogs";
import {errorToast} from "@/composables/useToasts";
import {watch} from "vue";

const {isPending, isError, sentEmails, viewEmailHtml} = useEmailLogs();

watch(() => isError.value, () => {
  if (isError.value) {
    errorToast('Something went wrong fetching the email logs. Please try again later.', 'Error fetching email logs')
  }
})

</script>

<template>
  <DataTable class="tw-w-full">
    <TableHeaderRow class="tw-grid-cols-16">
      <TableHeaderCell
        col-span="5"
        name="recipients"
      >
        <span>Recipients</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="7"
        name="subject"
      >
        <span>Subject</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="2"
        name="sent_at"
      >
        <span>Date Sent</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="2"
        name="view"
      />
    </TableHeaderRow>
    <div
      v-if="isPending && !isError"
      class="tw-bg-white tw-p-8 tw-rounded-lg"
    >
      <LoadingBlock />
    </div>

    <div
      v-else-if="sentEmails"
      class="tw-flex tw-flex-col tw-gap-4 tw-text-neutral-900 tw-text-base tw-mt-8"
    >
      <ZeroContent v-if="sentEmails?.length < 1">
        Looks like there are no emails to display.
      </ZeroContent>

      <TableRowRounded
        v-for="email in sentEmails"
        :key="email.id"
        class="tw-grid-cols-16"
      >
        <TableCell
          v-tooltip="{
            content: email.recipients.join(', '),
            theme: 'dark-blue-tooltip',
            placement: 'bottom',
          }"
          col-span="5"
          class="tw-flex tw-items-center tw-gap-4 tw-min-w-0"
        >
          <span class="tw-block tw-min-w-0 tw-truncate">
            {{ email.recipients.join(', ') }}
          </span>
        </TableCell>

        <TableCell
          v-tooltip="{
            content: email.subject,
            theme: 'dark-blue-tooltip',
            placement: 'bottom',
          }"
          col-span="7"
          class="tw-flex tw-items-center tw-gap-4 tw-min-w-0"
        >
          <span class="tw-block tw-min-w-0 tw-truncate">
            {{ email.subject }}
          </span>
        </TableCell>

        <TableCell col-span="2">
          {{ formatDate(email.sent_at) }}
        </TableCell>

        <TableCell col-span="2">
          <DefaultButton
            size="small"
            @click.prevent="viewEmailHtml(email)"
          >
            View
          </DefaultButton>
        </TableCell>
      </TableRowRounded>
    </div>
  </DataTable>
</template>
